export const SALES_DESK_HOME_ROW_COUNTS = [3, 1, 2] as const;
export type SalesDeskHomeRowCount = (typeof SALES_DESK_HOME_ROW_COUNTS)[number];

export function salesDeskHomeSlice<T>(rows: T[], count: number): T[] {
  const size = count === 1 || count === 2 ? count : 3;
  return rows.slice(0, size);
}

export function salesDeskBuildingsInProgress<T extends { saleStatus: string }>(orders: T[]): T[] {
  return orders.filter((order) => order.saleStatus.trim().toLowerCase() !== "closed");
}
